/**
 * OFF-FEED — Curated dispatches from the Abnormal World brand voice.
 *
 * Rules for curation:
 *   - Rider tone, ironic, short. No coach talk. No motivational quotes.
 *   - No sales talk. No products. No newsletter.
 *   - No dates. No author bylines. This is brand voice, not a blog.
 *   - Every line must earn its place. When in doubt, cut it.
 *
 * Categories:  THOUGHT · QUESTION · PROVOCATION · QUOTE · FIELD_NOTE
 * Sizes:       "sm" | "md" | "lg"
 */

/** @type {{ id:string, category:string, size?:"sm"|"md"|"lg", it:string, en:string }[]} */
export const DISPATCHES = [
    {
        id: "more-dust-less-algo",
        category: "PROVOCATION",
        size: "lg",
        it: "Più polvere. Meno algoritmi.",
        en: "More dust. Fewer algorithms.",
    },
    {
        id: "closed-trail-lets-see",
        category: "THOUGHT",
        size: "md",
        it: "Sentiero chiuso? Vediamo.",
        en: "Trail closed? Let's see.",
    },
    {
        id: "detours",
        category: "THOUGHT",
        size: "md",
        it: "Le deviazioni sono la parte più interessante.",
        en: "Detours are usually the good part.",
    },
    {
        id: "gps-brain",
        category: "PROVOCATION",
        size: "md",
        it: "GPS acceso. Cervello anche.",
        en: "GPS on. Brain on.",
    },
    {
        id: "maps-help-curiosity",
        category: "THOUGHT",
        size: "md",
        it: "Le mappe aiutano. La curiosità di più.",
        en: "Maps help. Curiosity helps more.",
    },
    {
        id: "no-superpowers",
        category: "THOUGHT",
        size: "md",
        it: "Niente superpoteri. Solo tanta voglia di pedalare.",
        en: "No superpowers. Just an actual urge to ride.",
    },
    {
        id: "welcome-argentario",
        category: "FIELD_NOTE",
        size: "sm",
        it: "Benvenuto sul Monte Argentario. Occhio ai cinghiali.",
        en: "Welcome to Monte Argentario. Mind the boars.",
    },
    {
        id: "same-line-queue",
        category: "PROVOCATION",
        size: "md",
        it: "Se tutti prendono la stessa linea, non è una linea. È una fila.",
        en: "If everyone takes the same line, it's not a line. It's a queue.",
    },
    {
        id: "quiet-06-12",
        category: "FIELD_NOTE",
        size: "md",
        it: "Argentario, 06:12. Vento da nord-ovest. Nessuno in giro. Momento giusto.",
        en: "Argentario, 06:12. Northwest wind. No one around. Good moment.",
    },
    {
        id: "algo-vs-trail",
        category: "PROVOCATION",
        size: "lg",
        it: "L'algoritmo ti mostra quello che hai già amato. Il trail ti mostra quello che ancora non conosci.",
        en: "The algorithm shows you what you already liked. The trail shows you what you don't know yet.",
    },
    {
        id: "friends-sunday",
        category: "FIELD_NOTE",
        size: "sm",
        it: "Domenica, quattro amici, una birra dopo. Serve altro?",
        en: "Sunday. Four friends. One beer after. What else?",
    },
    {
        id: "question-fun",
        category: "QUESTION",
        size: "md",
        it: "Da quando divertirsi è diventato un progetto?",
        en: "Since when did having fun become a project?",
    },
    {
        id: "parassiti-storm",
        category: "FIELD_NOTE",
        size: "sm",
        it: "Parassiti, dopo il temporale. La roccia parla diversamente da bagnata.",
        en: "Parassiti, after the storm. Wet rock talks differently.",
    },
    {
        id: "borrowed",
        category: "PROVOCATION",
        size: "md",
        it: "La maggior parte delle opinioni che hai non sono tue. Sono in prestito.",
        en: "Most of the opinions you hold aren't yours. They're on loan.",
    },
    {
        id: "quote-shortcut",
        category: "QUOTE",
        size: "md",
        it: "«Non esiste una scorciatoia per un pensiero originale.»",
        en: "«There's no shortcut to an original thought.»",
    },
    {
        id: "question-map",
        category: "QUESTION",
        size: "sm",
        it: "Da quando hai smesso di guardare la mappa e hai iniziato a fidarti?",
        en: "When did you stop reading the map and start trusting?",
    },
];

export const CATEGORIES = ["THOUGHT", "QUESTION", "PROVOCATION", "QUOTE", "FIELD_NOTE"];

/** Fisher–Yates shuffle. */
export function shuffled(list) {
    const arr = [...list];
    for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
}
